import React from "react";
import { FaFacebook, FaTwitter, FaWhatsapp, FaClipboard, FaInstagram } from "react-icons/fa";

export default function SocialShare({ title, text, url, instagramUser }) {
  const shareUrl = encodeURIComponent(url);
  const shareText = encodeURIComponent(text || title);

  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
  const twitterUrl = `https://twitter.com/intent/tweet?text=${shareText}&url=${shareUrl}`;
  const whatsappShare = `https://api.whatsapp.com/send?text=${shareText}%20${shareUrl}`;
  const instagramUrl = instagramUser
    ? `https://www.instagram.com/${instagramUser}/`
    : null;

  const copyLink = async () => {
    await navigator.clipboard.writeText(url);
    alert("✅ Enlace copiado. ¡Pégalo en tu historia o bio de Instagram!");
  };

  return (
    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
        <h3>Comparte el contenido en:</h3>
      {/* Facebook */}
      <a
        href={facebookUrl}
        target="_blank"
        rel="noopener noreferrer"
        title="Compartir en Facebook"
      >
        <FaFacebook size={28} color="#1877F2" className="iconSS" />
      </a>

      {/* X (Twitter) */}
      <a
        href={twitterUrl}
        target="_blank"
        rel="noopener noreferrer"
        title="Compartir en X"
      >
        <FaTwitter size={28} color="#1DA1F2" className="iconSS" />
      </a>

      {/* Whatsapp */}
      <a
        href={whatsappShare}
        target="_blank"
        rel="noopener noreferrer"
        title="Compartir en X"
      >
        <FaWhatsapp size={28} color="#1DA1F2" className="iconSS" />
      </a>

      {/* Clipboard */}
      <button
        onClick={copyLink}
        className="btnSvg"
        title="Copiar enlace para Instagram"
        style={{background:"transparent", border:"none", cursor: "pointer"}}
      >
        <FaClipboard size={28} color="#1DA1F2" className="iconSS" />
      </button>

    </div>
  );
}